import { render } from "./TrusteesComment.vue?vue&type=template&id=bc096adc&scoped=true"
import script from "./TrusteesComment.vue?vue&type=script&lang=js"
export * from "./TrusteesComment.vue?vue&type=script&lang=js"

import "./TrusteesComment.vue?vue&type=style&index=0&id=bc096adc&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc096adc"]])

export default __exports__